var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React, { useEffect, useRef, useState } from 'react';
import { FONTS, SIZES, Typography } from '@fupa/fupa-uikit';
import styled from 'styled-components';
import MatchScoreContainer from 'app/components/tv/customControls/MatchScoreContainer';
import TeamEmblem from 'app/components/tv/customControls/TeamEmblem';
const Wrapper = styled.div.withConfig({
  componentId: "sc-182f30v-0"
})(["background-color:rgba(0,0,0,0.4);height:", ";border-radius:", ";display:", ";align-items:center;width:", ";transition:width 0.5s;max-width:80%;overflow:hidden;", ""], SIZES['24'], SIZES['12'], props => props.show ? 'flex' : 'none', props => "".concat(props.barwidth, "px"), props => props.theme.desktopLayout(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    height: ", ";\n    border-radius: ", ";\n  "])), SIZES['40'], SIZES['20']));
const Score = styled(Typography).withConfig({
  componentId: "sc-182f30v-1"
})(["font-size:", ";padding:0 ", ";color:white;white-space:nowrap;", ""], FONTS['18'], SIZES['4'], props => props.theme.desktopLayout(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: ", ";\n  "])), SIZES['24']));
const TitleContainer = styled.div.withConfig({
  componentId: "sc-182f30v-2"
})(["margin:0 ", ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"], SIZES['8']);
const Title = styled(Typography).withConfig({
  componentId: "sc-182f30v-3"
})(["font-size:", ";line-height:", ";@media only screen and (max-width:640px){font-size:", ";line-height:", ";}", ""], FONTS['16'], SIZES['20'], SIZES['14'], SIZES['20'], props => props.theme.desktopLayout(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), SIZES['20'], SIZES['28']));
const OVERFLOW_THRESHOLD = 20;
export const MatchScoreOverlay = _ref => {
  var _video$match, _video$match2;
  let {
    video,
    show
  } = _ref;
  const titleRef = useRef(null);
  const scoreContainerRef = useRef(null);
  const [barWidth, setBarWidth] = useState(0);
  useEffect(() => {
    let shrinkTimeout = null;
    const updateBarWidth = () => {
      const videoTitle = titleRef.current;
      const scoreContainer = scoreContainerRef.current;
      if (videoTitle && scoreContainer) {
        if (shrinkTimeout) {
          window.clearTimeout(shrinkTimeout);
        }
        const titleWidth = videoTitle.scrollWidth;
        const scoreWidth = scoreContainer.scrollWidth;
        setBarWidth(scoreWidth + titleWidth + OVERFLOW_THRESHOLD);
        shrinkTimeout = window.setTimeout(() => setBarWidth(scoreWidth), 5000);
      }
    };
    updateBarWidth();
    window.addEventListener('resize', updateBarWidth);
    window.addEventListener('orientationchange', updateBarWidth);
    return () => {
      if (shrinkTimeout) {
        window.clearTimeout(shrinkTimeout);
      }
      window.removeEventListener('resize', updateBarWidth);
      window.removeEventListener('orientationchange', updateBarWidth);
    };
  }, [video.title]);
  if (!video.hasResult()) return null;
  return /*#__PURE__*/React.createElement(Wrapper, {
    show: show,
    barwidth: barWidth,
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "MatchScoreOverlay",
    "data-sentry-source-file": "MatchScoreOverlay.tsx"
  }, /*#__PURE__*/React.createElement(MatchScoreContainer, {
    link: video.getMatchLink(),
    ref: scoreContainerRef,
    "data-sentry-element": "MatchScoreContainer",
    "data-sentry-source-file": "MatchScoreOverlay.tsx"
  }, /*#__PURE__*/React.createElement(TeamEmblem, {
    team: (_video$match = video.match) === null || _video$match === void 0 ? void 0 : _video$match.homeTeam,
    "data-sentry-element": "TeamEmblem",
    "data-sentry-source-file": "MatchScoreOverlay.tsx"
  }), /*#__PURE__*/React.createElement(Score, {
    variant: "result",
    "data-sentry-element": "Score",
    "data-sentry-source-file": "MatchScoreOverlay.tsx"
  }, video.homeGoal, " : ", video.guestGoal), /*#__PURE__*/React.createElement(TeamEmblem, {
    team: (_video$match2 = video.match) === null || _video$match2 === void 0 ? void 0 : _video$match2.awayTeam,
    "data-sentry-element": "TeamEmblem",
    "data-sentry-source-file": "MatchScoreOverlay.tsx"
  })), /*#__PURE__*/React.createElement(TitleContainer, {
    ref: titleRef,
    "data-sentry-element": "TitleContainer",
    "data-sentry-source-file": "MatchScoreOverlay.tsx"
  }, /*#__PURE__*/React.createElement(Title, {
    variant: "title1",
    "data-sentry-element": "Title",
    "data-sentry-source-file": "MatchScoreOverlay.tsx"
  }, video.title)));
};